module.exports = __webpack_public_path__ + "media/gun_3.54eef8ee.mp3";